import React, { createContext, useState, useCallback } from 'react';
import Notification from '../components/common/Notification'; // Sesuaikan path jika perlu

export const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, severity = 'info', title = '') => {
    setNotification({ message, severity, title, key: Date.now() });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  const value = { showNotification, hideNotification };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {notification && (
        <Notification
          open={!!notification}
          message={notification.message}
          severity={notification.severity}
          title={notification.title}
          onClose={hideNotification}
        />
      )}
    </NotificationContext.Provider>
  );
};
